import {Component, OnInit} from '@angular/core';
import {AppConfigService} from "../../../config/app-config.service";
import {EuModel} from "../../../config/eu/eu.model";
import {HttpClient} from "@angular/common/http";
import {LogoModel} from "../../../config/eu/logo.model";
import {TranslateService} from "../../../shared/translate.service";
import {LogRoutingService} from "../../../log/log-routing.service";
import {Router, RoutesRecognized} from "@angular/router";
import {filter} from "rxjs/operators";

@Component({
  selector: 'app-eu-info',
  templateUrl: './eu-info.component.html',
  styleUrls: ['./eu-info.component.scss']
})
export class EuInfoComponent implements OnInit {

  config: EuModel;

  omnisLogoSrc: string;

  omnisLogoWcagSrc: string;

  logoUrls: LogoModel;

  language: string;

  homePage: boolean = false;

  private basePath = '/assets/config/eu/';

  constructor(private appConfig: AppConfigService, private http: HttpClient, private translateService: TranslateService,
              private router: Router) {
    this.router.events
      .pipe(
        filter((e: any) => e instanceof RoutesRecognized)
      ).subscribe((e: RoutesRecognized) => {
      this.homePage = LogRoutingService.resolveActionSource(e.url, false) === 'url'
    });
  }

  ngOnInit() {
    this.init();
  }


  private init() {
    this.language = this.translateService.language;
    this.config = this.appConfig.euConfig;
    this.initImages(this.language, this.config);
    this.translateService.languageChanged.subscribe(language => {
      this.language = language;
      this.initImages(language, this.config);
    })
  }

  private initImages(language: string, config: EuModel) {
    const path = this.basePath + this.language + '/';

    if (config.languages) {
      const langObject = config.languages.find(l => l.language === language);
      if (langObject) {
        this.omnisLogoSrc = this.basePath + config.omnisLogo;
        this.omnisLogoWcagSrc = this.basePath + config.omnisLogoWcag;
        this.logoUrls = new LogoModel(
          path + langObject.logo.efrr,
          path + langObject.logo.efrrWcag,
          path + langObject.logo.fePopc,
          path + langObject.logo.fePopcWcag,
        );
      }
    } else {
      console.error("Brak konfiguracji dla komponentu eu-info");
    }
  }
}
